/**
 * Created by quikr on 8/1/16.
 */
import * as types from "./actionTypes";

export function beginAjaxCall() {
  return {type: types.BEGIN_AJAX_CALL};
}
export function endAjaxCall() {
  return {type: types.END_AJAX_CALL};
}



/** WEBPACK FOOTER **
 ** ./src/redux/actions/ajaxStatusActions.js
 **/